import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { FilterModel, SortModelItem } from 'ag-grid-community'
import { PageResponse } from '../../../shared/models/page-response'

import { AccueilDto } from './dto/accueil.dto'
import { environment } from '../../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class AccueilHttp {
  static readonly filterOperators: Record<string, string> = {
    contains: 'cn',
    equals: 'eq',
    notContains: 'nc',
    notEqual: 'ne',
    greaterThanOrEqual: 'ge',
    lessThanOrEqual: 'le',
    greaterThan: 'gt',
    lessThan: 'lt',
    inRange: 'btw',
  }

  private readonly http = inject(HttpClient)
  private readonly baseUrl = environment.baseUrl + '/accueil'

  findAccueilByChantier(
    codeChantier: string,
    pageSize: number,
    pageNumber: number,
    sortModel: SortModelItem[],
    filterModel: FilterModel,
  ): Observable<PageResponse<AccueilDto>> {
    let params: HttpParams = new HttpParams()
    if (Number.isInteger(pageSize) && Number.isInteger(pageNumber)) {
      params = params.append('size', pageSize).append('page', pageNumber)
    }
    for (const sortModelItem of sortModel) {
      params = params.append('sort', `${sortModelItem.colId}:${sortModelItem.sort}`)
    }
    if (filterModel) {
      for (const [key, value] of Object.entries(filterModel)) {
        const op = AccueilHttp.filterOperators[value.type]
        const opPart = op ? `${op}:` : ''
        const searchValue = `${key}:${opPart}${value.filter || ''}`
        params = params.append('search', searchValue)
      }
    }
    return this.http.get<PageResponse<AccueilDto>>(`${this.baseUrl}/find/chantier/${codeChantier}`, { params })
  }

  findById(id: number): Observable<AccueilDto> {
    return this.http.get<AccueilDto>(`${this.baseUrl}/findById/${id}`)
  }

  update(
    id: number,
    changes: {
      dateEntree?: string | null
      dateSortie?: string | null
      commentaire?: string | null
      lienDriveTitreSejour?: string | null
    },
  ): Observable<AccueilDto> {
    return this.http.put<AccueilDto>(`${this.baseUrl}/update/${id}`, changes)
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/delete/${id}`)
  }

  generatePdf(codeChantier: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/generate-pdf/${codeChantier}`, null, {
      responseType: 'blob',
    })
  }
}
